/* eslint-disable no-param-reassign */

import CalibrationKeys from '../../../../../models/enums/calibrations/calibration-keys.enum';
import { parseDatabaseValue } from '../../../../../utilities';
import { parseCellValue } from '../../../../ValuationsAllocation/util';
import { IReverseParserCalibrationParams } from '../../guidelinePublicCompanies/PerformanceMetrics/config/reverseParser/types';
import { ICellChange } from '../../guidelinePublicCompanies/PerformanceMetrics/config/utils/types';

const reverseParserCalibration = (params: IReverseParserCalibrationParams) => {
  const { cells, tableData, fieldAttributes } = params;

  const { approaches } = tableData;
  const calibrationDate = cells.A2.value?.toString() ?? '';
  const transactionAllocationMethod = cells.A3.value?.toString() ?? '';
  const publicCompsApproachCalibration = cells.A9?.value ?? null;
  const selectedFinancialVersion = Number(cells.A10?.value ?? '0');

  const lessDebt = cells.A5.value || 0;
  const plusCash = cells.A6.value || 0;

  const updatedEquityCellValue = parseCellValue({ cell: cells.A7, fieldDecimalPlaces: 0 });
  const updatedEnterpriseCellValue = parseCellValue({ cell: cells.A4, fieldDecimalPlaces: 0 });

  const approachesIds = approaches?.map(approach => approach.id);

  let selectedExistingApproach = [] as any;
  let newApproachSelected = null;

  if ((approaches ?? []).length > 0) {
    selectedExistingApproach = approachesIds?.find(id => id?.toString() === publicCompsApproachCalibration?.toString());
    if (selectedExistingApproach) {
      tableData.calibration.public_comps_approach_calibration = Number(publicCompsApproachCalibration);
      tableData.calibration.temp_public_comps_reference = null;
    }
  }
  if (!selectedExistingApproach) {
    newApproachSelected = approaches?.find(approach => approach.panelId === publicCompsApproachCalibration?.toString());
    if (newApproachSelected) {
      tableData.calibration.public_comps_approach_calibration = null;
      tableData.calibration.temp_public_comps_reference = newApproachSelected?.panelId?.toString() ?? '';
    }
  }

  tableData.calibration.calibration_date = calibrationDate;
  tableData.calibration.transaction_allocation_method = transactionAllocationMethod;
  tableData.calibration.enterprise_value_inputs = updatedEnterpriseCellValue;
  tableData.calibration.equity_value_inputs = updatedEquityCellValue;
  tableData.calibration.financials_version = selectedFinancialVersion;

  if (tableData.calibration.data_updated) {
    // these fields within the calibration table require the use of the DB calibration attributes relative to the cell value
    const calibrationFields: { keyName: CalibrationKeys; cell: ICellChange }[] = [
      { keyName: CalibrationKeys.LTM_REVENUE_INPUTS, cell: cells.A11 },
      { keyName: CalibrationKeys.NTM_REVENUE_INPUTS, cell: cells.A12 },
      { keyName: CalibrationKeys.LTM_EBITDA_INPUTS, cell: cells.A13 },
      { keyName: CalibrationKeys.NTM_EBITDA_INPUTS, cell: cells.A14 },
    ];

    // iterate over the necessary fields, parse the cell value using rules provided by DB or if no value default to 0
    calibrationFields.forEach(field => {
      const { keyName: currentKey, cell: currentCell } = field;
      const currentAttribute = fieldAttributes.calibrationAttrs[currentKey];

      tableData.calibration[currentKey] = currentAttribute
        ? parseDatabaseValue({
          gridType: '',
          value: currentCell.value,
          format: currentCell.format,
          type: currentAttribute.type,
          decimalPlaces: parseInt(`${currentAttribute.decimal_places}`),
        })
        : (currentCell.value || 0).toString();
    });
  }

  tableData.calibration.data_updated = true;

  tableData.calibration.plus_cash_inputs = plusCash.toString();
  tableData.calibration.less_debt_inputs = lessDebt.toString();
};

export default reverseParserCalibration;
